let json 
try {
    json = localStorage.getItem('user');
} catch (error) {
    console.log(error)
}
const user = json !== 'undefined' && json ? JSON.parse(json) : null;

const initialState = {
    user: user?.user ? user.user : '',
    access_token: user?.access_token ? user.access_token : '',
    isLogged: user?.access_token ? true : false,
}

export default function userReducer(PrevState = initialState, action){
    switch (action.type) {
        case 'SignIn':
            return{
                ...PrevState,
                user : action.payload.user,
                access_token: action.payload.access_token,
                isLogged: true
            };
        case 'LogOut':
            return {
                ...PrevState,
                user: '',
                access_token: '',
                isLogged: false,
            };
        case 'ChangeUserInfo' :
            return{
                ...PrevState,
                user : action.payload.user,
            };
        default:
            return PrevState;
    }
}